// extracted by mini-css-extract-plugin
module.exports = {"button":"PromoPrimaryButton_button__PApWS","button_primary":"PromoPrimaryButton_button_primary__l76JO"};